/**
 * Created by hp on 2017/7/19.
 */
const defaults = {
    inviteInitialized: false,
    platformInitialized: false,
    outerInitialized: false,
};

export default(state = defaults, action) => {
    switch (action.type) {
        case 'DATACENTERDETAIL_INVITE_INIT':
            return {...state, inviteInitialized: true, ...action.payload};
        case 'DATACENTERDETAIL_PLATFORM_INIT':
            return {...state, platformInitialized: true, ...action.payload};
        case 'DATACENTERDETAIL_OUTER_INIT':
            return {...state, outerInitialized: true, ...action.payload};
        case 'DATACENTERDETAIL_PAGE_UNMOUNT':
            return {...state, inviteInitialized: false, platformInitialized: false, outerInitialized: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dataCenterDetail.js